import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/qualficationConfigs',
        name: 'qualficationConfigs',
        meta: { sideMenuLabel: "Qualifiche network" },
        component: () => import("./views/qualficationConfigs.vue")
    },
    {
        path: '/qualficationConfigsPersonal',
        name: 'qualficationConfigsPersonal',
        meta: { sideMenuLabel: "Qualifiche personal" },
        component: () => import("./views/qualficationConfigsPersonal.vue")
    },
];

export default routes;